import { render, staticRenderFns } from "./ButtonVerifyEmailAddress.vue?vue&type=template&id=f3b64f30&scoped=true&"
import script from "./ButtonVerifyEmailAddress.vue?vue&type=script&lang=js&"
export * from "./ButtonVerifyEmailAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b64f30",
  null
  
)

export default component.exports